module.exports = __webpack_public_path__ + "img/banco-pacifico.7dcaec58.png";